import { getGlobalConfig } from '../../config/config'
import { CLEAR_ALL_BRANCH, CLEAR_BRANCH_LOADING } from './BranchActions'
import { CLEAR_ALL_BRANCHES_FINANCE, CLEAR_BRANCHES_FINANCE_LOADING } from './BranchesFinanceActions'
import { CLEAR_ALL_MODULES, CLEAR_MODULES_LOADING } from './ModulesActions'
import { CLEAR_ALL_ROLE, CLEAR_ROLE_LOADING } from './RoleActions'

import { handleError } from '../../utils/utils'
import { CLEAR_TRANSLATIONS_LOADING } from './TranslationsActions'

export const GET_GLOBALCONFIG_REQUEST = 'GET_GLOBALCONFIG_REQUEST'
export const GET_GLOBALCONFIG_SUCCESS = 'GET_GLOBALCONFIG_SUCCESS'
export const GET_GLOBALCONFIG_ERROR = 'GET_GLOBALCONFIG_ERROR'
export const CLEAR_GLOBALCONFIG = 'CLEAR_GLOBALCONFIG'


const actions = {
  clearLoading: () => async (dispatch) => {

    // dispatch({
    //   type: CLEAR_AUTH_LOADING
    // })
    // dispatch({
    //   type: CLEAR_BRANCH_LOADING
    // })
    dispatch({
      type: CLEAR_BRANCHES_FINANCE_LOADING
    })
    dispatch({
      type: CLEAR_MODULES_LOADING
    })
    dispatch({
      type: CLEAR_ROLE_LOADING
    })
    dispatch({
      type: CLEAR_TRANSLATIONS_LOADING
    })
  },
  // Get All global variables
  getGlobalConfig: () => async (dispatch) => {
    dispatch({
      type: GET_GLOBALCONFIG_REQUEST,
    })
    await getGlobalConfig().then((res) => {
      if (res?.status === 200) {
        let countries = []
        let currencies = []
        if (res.data.countries) {
          countries = [...res.data.countries]
          countries.sort((a, b) => a.countryName.localeCompare(b.countryName))
          res.data.countries = countries
        }
        if (res.data.currencies) {
          currencies = [...res.data.currencies]
          currencies.sort((a, b) => a.currencyName.localeCompare(b.currencyName))
          res.data.currencies = currencies
        }
        dispatch({
          type: GET_GLOBALCONFIG_SUCCESS,
          payload: res.data,
        })
      } else {
        handleError(dispatch)(res, GET_GLOBALCONFIG_ERROR, 'GET GLOBALS ERROR')
        // dispatch({
        //   type: GET_GLOBALCONFIG_ERROR,
        //   payload: {
        //     message: parseError(res?.data?.error) || res?.data?.message || 'get globals error',
        //   },
        // })
      }
    })
  },
  clearGlobalConfig: () => (dispatch) => {
    dispatch({
      type: CLEAR_GLOBALCONFIG
    })
  },


  clearAllData: () => (dispatch) => {
    // dispatch({
    //   type: CLEAR_DESIGN_SETUP
    // })
    // dispatch({
    //   type: CLEAR_APP_USERS_GROUPS
    // })
    dispatch({
      type: CLEAR_ALL_BRANCH
    })
    // dispatch({
    //   type: CLEAR_MESSAGES
    // })
    dispatch({
      type: CLEAR_ALL_BRANCHES_FINANCE
    })
    // dispatch({
    //   type: CLEAR_ALL_USER
    // })
  }
}

export default actions
